import { render } from "./NewBroker.vue?vue&type=template&id=28e0f6c9"
import script from "./NewBroker.vue?vue&type=script&lang=js"
export * from "./NewBroker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__